/**
 * Reducer for guest board list places. This data is used to persist/rehydrate
 * the guest board data
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Yucho Ho
 */
import produce from 'immer'
import pickBy from 'lodash/pickBy'
import { merge } from 'client/shared/js/utils/object'
import * as TYPES from '../types'

const initialState = {}

// ------------------------------------
// Reducer
// ------------------------------------
export default produce((draft, action) => {
  const { lpid } = action.data?.result ?? {}
  const { listPlaces } = action.data?.entities ?? {}

  switch (action.type) {
    case TYPES.GUEST_CREATE_BOARD:
      return initialState

    // These logic should be in sync with the actual listPlaces reducer
    case TYPES.GUEST_ADD_PLACE:
    case TYPES.GUEST_UPDATE_PLACE:
    case TYPES.GUEST_REORDER_PLACES_BETWEEN_LISTS:
    case TYPES.GUEST_ADD_LIST_PLACE_TAG:
    case TYPES.GUEST_DELETE_LIST_PLACE_TAG:
      merge(draft, listPlaces)
      break

    case TYPES.GUEST_DELETE_PLACE:
      delete draft[lpid]
      break
  }
}, initialState)

// ------------------------------------
// Selectors
// ------------------------------------
const selectGuestListPlace = (state, listPlaceId) => {
  return state[listPlaceId] ?? {}
}

const selectGuestListPlacesWithGpid = (state) => {
  return pickBy(state, ({ gpid }) => gpid)
}

export const selectors = {
  selectGuestListPlace,
  selectGuestListPlacesWithGpid
}
